import React from 'react'
import FranchiseListTable from '../../components/Merchant/FranchiseListTable';

const FranchiseList = () => {
  return (
    <FranchiseListTable />
  )
}

export default FranchiseList;